/**
 * Used in Storybook (and available for tests) to exercise the loading/ready/error lifecycle without
 * a running onboard-service.
 */
export class MockAiAssistantClient {
    options;
    constructor(options = {}) {
        this.options = options;
    }
    async createSession() {
        const { delayMs = 0, failureMessage, sessionId: optSessionId } = this.options;
        if (delayMs > 0) {
            await new Promise((resolve) => {
                setTimeout(resolve, delayMs);
            });
        }
        if (failureMessage) {
            throw new Error(failureMessage);
        }
        const sessionId = optSessionId ?? `mock-session-${Math.random().toString(36).slice(2)}`;
        return { sessionId };
    }
}
